/**
 * pageAccess.js — hangi rolün SAYFALARINI açabildiğimiz (backlog #302, 2026-10-08).
 *
 * Sayfalar rol id'siyle açılıyor: her rotanın `roles` dizisi (allRoutes.js) ve menü listesi
 * (MainContext.js api.groups) sabit id'ler sayıyor. Yetki Yönetimi'nden yeni oluşturulan bir rolün
 * (id 22+) id'si bu dizilerin hiçbirinde yok — eskiden kullanıcıları hiçbir sayfayı açamıyordu.
 * Artık her rolün bir "sayfa erişimi rolü" var (backend: user_group.page_access_group_id, V70):
 * yeni rol, şablon rolünün sayfalarını ve menüsünü alır. Hazır roller kendi id'lerini kullanır.
 *
 * Kural: SAYFA / MENÜ / sayfa içi "bu sekme kime açık" kararları bu dosyadaki id'yi kullanır.
 * Firma mı personel mi (tenancy) kararı GERÇEK rol id'siyle verilir — firmaSessionService
 * getCurrentUserGroupId. Yeni roller yalnızca personel şablonundan türüyor, ikisi aynı sonucu verir.
 *
 * groupInfo = GET /users/user/{id}/group yanıtı (MainContext girişte localStorage'a yazar):
 * { id, userGroupName, pageAccessGroupId, userGroupEntity: { id, pageAccessGroupId, ... } }.
 * pageAccessGroupId'i henüz göndermeyen eski bir backend'de id'ye düşer — davranış eskisi gibi.
 * Rolün sayfa erişimi değişince kullanıcı bir sonraki girişinde görür (localStorage önbelleği).
 *
 * #408 (2026-10-14): backend'de user_group.page_access_group_id sütunu ve PUT /rbac/groups/{id}/page-access SİLİNDİ (V94); sayfalar
 * artık sayfa yetkileriyle açılır (#325). pageAccessGroupIdOf bundan sonra hep rolün KENDİ id'sini verir (backend takma adı olarak
 * pageAccessGroupId = id göndermeye devam eder, göndermezse buradaki geri dönüş id'ye düşer). Yeni kod buna güvenmesin: yetki anahtarına bakın.
 */

export function pageAccessGroupIdOf(groupInfo) {
  const raw =
    groupInfo?.pageAccessGroupId ??
    groupInfo?.userGroupEntity?.pageAccessGroupId ??
    groupInfo?.id ??
    groupInfo?.userGroupEntity?.id;
  const id = Number(raw);
  return raw === null || raw === undefined || !Number.isFinite(id) ? null : id;
}

/** Giriş yapan kullanıcının sayfa erişimi rol id'si; giriş yoksa null. */
export function getCurrentPageAccessGroupId() {
  try {
    return pageAccessGroupIdOf(JSON.parse(localStorage.getItem('groupInfo')));
  } catch {
    return null;
  }
}
